import React from "react"
import { isMobile } from "react-device-detect"
import { useQuery } from "react-query"
import { request } from "../../../../util/request"
import { PostListItem } from "../../../posts/PostListItem"
import { RequestError } from "../../../shared/RequestError"
import { Spinner } from "../../../shared/Spinner"
import { OtherBandsSection } from "../../../bands/OtherBandsSection"
import BandHeader from "../../BandHeader"
import type { Band } from "../../../../types/bands"

interface Post {
  id: string
  [key: string]: any
}

interface TimelineTemplateProps {
  band: Band
}

const TimelineTemplate: React.FC<TimelineTemplateProps> = ({ band }) => {
  const { data, status } = useQuery(
    [
      "band_highlights",
      {
        path: `/api/v1/bands/${band.id}/posts/highlights`,
      },
    ],
    request,
  )
  const width = window.innerWidth

  return (
    <div className="col-span-12">
      <BandHeader band={band} headerMode="coverImage" />

      <div
        className="grid grid-cols-12 pb-24"
        style={{
          marginTop: isMobile ? "0px" : `${width * -2.93}px`,
          position: "relative",
        }}
      >
        <div
          className="lg:col-span-4 pr-3 hidden lg:block px-3 lg:px-4"
          style={{ marginTop: `${width * 0.26}px` }}
        >
          <OtherBandsSection
            bandId={band.id}
            bandName={band.name}
            colClass="lg:grid-cols-2 grid-cols-2"
          />
        </div>
        <div className="lg:col-span-8 col-span-12 px-3 lg:px-4">
          {status === "loading" ? (
            <Spinner className="text-gray-500" />
          ) : status === "error" ? (
            <RequestError error={data?.error} />
          ) : (
            <ul className="list-unstyled">
              {data?.posts?.map((post: Post) => (
                <PostListItem key={post.id} post={post} />
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}

export default TimelineTemplate
